import { Suspense } from 'react';
import { useRouter } from 'next/router';

import Icon from '@utilities/icon';
import { colorPallete } from '@configs/color-pallete';
import { routeList } from '@routes/routeList';

type BackIconProps = { route?: string };

const BackIconContent = ({ route }: BackIconProps) => {
  const { push, back, query } = useRouter();

  const fromHome = query?.fromHome;
  const fromNobat = query?.fromNobat;
  const fromOcsHome = query?.fromOcsHome;
  const fromSpecialities = query?.fromSpecialities;

  const backButtonClickHandler = () => {
    if (fromHome) {
      push(routeList?.homeRoute);
    } else if (fromOcsHome) {
      push(routeList?.ocsHome);
    } else if (fromNobat) {
      push(routeList?.nobatHome);
    } else if (fromSpecialities) {
      push(routeList?.specialities);
    } else if (route) {
      push(route);
    } else if (typeof window !== 'undefined' && window.history.length > 1) {
      back();
    }
  };

  return (
    <div
      onClick={backButtonClickHandler}
      tabIndex={0}
      role="button"
      onKeyDown={() => {
        return;
      }}
      className="pr-4"
    >
      <Icon
        name="ArrowRight"
        width={1.5}
        height={1.5}
        fill={colorPallete?.content?.primary}
      />
    </div>
  );
};

const BackIcon = ({ route }: BackIconProps) => {
  return (
    <Suspense
      fallback={
        <div>
          <Icon
            name="ArrowRight"
            width={1.5}
            height={1.5}
            fill={colorPallete?.content?.primary}
          />
        </div>
      }
    >
      <BackIconContent route={route} />
    </Suspense>
  );
};

export default BackIcon;
